import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { UserResponse } from 'src/app/interfaces/user';
import { HttpHelperService } from 'src/app/shared/services/http-helper/http-helper.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

	constructor(
		private readonly httpHelperService: HttpHelperService,
		private readonly http: HttpClient,
	) { }

	getUser(totken): Observable<Partial<UserResponse>> {
		const params = new HttpParams().set('token', totken);
		return this.httpHelperService.get('/auth/authenticate', params);
	  }
	
	  getUserMock(totken): Observable<Partial<UserResponse>> {
		const params = new HttpParams().set('token', totken);
		return this.httpHelperService.get('/auth/authenticate/mock', params);
	  }
	
	backToSAT(userId: string) {
		return this.httpHelperService.get(`/session/alpha-sat/SAT_SYS_URL?switch&userId=${userId}`);
	}

	redirectSAT(payload: any) {
		return this.httpHelperService.get(`/session/alpha-sat/${payload.code}?switch&userId=${payload.userId}`);
	}
	
	signOut(userId?: string) {
		const logoutUrl = `${environment.commonSvcUrl}/auth/logout`;
		return this.http.post(logoutUrl, {}, { withCredentials: true });
	}

	redirectToAlphaCCentric(payload: any) {
		return this.httpHelperService.get(`/session/logout?switchOcc&userId=${payload.userId}&opportunityId=${payload.opportunityId}&agentCode=${payload.agentCode}`);
	}

	crossSellIssueNewRedirectToAlpha(payload: any) {
		const { action, productType, productCode, agentCode, idType, idValue, clientType, userId, documentNo } = payload;

		let queryParamsString = ``;

		if (action) {
			queryParamsString = queryParamsString.concat(`&action=${action}`);
		}

		if (documentNo) {
			queryParamsString = queryParamsString.concat(`&documentNo=${documentNo}`);
		}

		if (productType) {
			queryParamsString = queryParamsString.concat(`&productType=${productType}`);
		}

		if (productCode) {
			queryParamsString = queryParamsString.concat(`&productCode=${productCode}`);
		}

		if (agentCode) {
			queryParamsString = queryParamsString.concat(`&agentCode=${agentCode}`);
		}

		if (idType) {
			queryParamsString = queryParamsString.concat(`&idType=${idType}`);
		}

		if (idValue) {
			queryParamsString = queryParamsString.concat(`&idValue=${idValue}`);
		}

		if (clientType) {
			queryParamsString = queryParamsString.concat(`&clientType=${clientType}`);
		}

		if (userId) {
			queryParamsString = queryParamsString.concat(`&userId=${userId}`);
		}

		return this.httpHelperService.get(`/session/logout?switch${queryParamsString}`);
	}
  
}
